import { useState } from 'react'

import {
  Alert,
  Box,
  Flex,
  TextSpan,
} from 'app/components/design-system-components'
import { SearchRounded } from 'app/components/design-system-components/icons/actions'
import { Input } from 'app/components/design-system-components/inputs'
import { CheckboxesList } from 'app/components/design-system-components/list-filters/CheckboxesList'
import { DropdownBodySectionHeader } from 'app/components/design-system-components/list-filters/DropdownBodySectionHeader'
import UpgradeButton from 'app/components/design-system-components/UpgradeButton'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

const podsFilterFields = {
  pods: 'pods',
}

export const podFilterDataExtractor = (filterValues: any) => {
  const { [podsFilterFields.pods]: podsObj } = filterValues
  return {
    pods: Object.values(podsObj || {}).map(({ option }: any) => option),
  }
}

export const PodsAppliedFilterRenderer = ({ filterValues }: any) => {
  const { [podsFilterFields.pods]: podsObj } = filterValues
  return Object.values(podsObj)
    .map((podOption: any) => podOption?.optionMeta?.displayText)
    .join(', ')
}

export const isPodsApplied = (podsFilterValues: any) => {
  return (
    podsFilterValues &&
    podsFilterValues[podsFilterFields.pods] &&
    Object.values(podsFilterValues[podsFilterFields.pods]).length
  )
}

export const getPodsFilterState = (pods: any) =>
  Object.values(pods?.pods || {}).map(({ option }: any) => option?.id)

const PodsOptionsList = ({
  listTitle,
  options,
  selectedOptions,
  onCheckBoxClicked,
}: any) => {
  if (!options || !options.length) return null
  return (
    <>
      <DropdownBodySectionHeader
        header={listTitle}
        containerProps={{ mb: theme.space[4] + 'px' }}
      />
      <CheckboxesList
        options={options}
        onCheckBoxClicked={onCheckBoxClicked}
        checkedOptions={selectedOptions}
      />
    </>
  )
}

export const PodsFilterBody = ({
  formBag: { values, setFieldValue },
  pods,
  disabled,
}: any) => {
  const [searchText, setSearchText] = useState('')

  const onSearchTextChange = ({ target: { value } }: any) => {
    setSearchText(value)
  }

  const options = pods
    ?.map((pod: any) => {
      const { id, name } = pod
      return {
        option: pod,
        optionMeta: {
          id: id,
          displayText: name,
        },
      }
    })
    .filter(({ optionMeta: { displayText } }: any) =>
      displayText.toLowerCase().includes(searchText.toLowerCase()),
    )

  const onCheckBoxClicked = (checked: any, option: any) => {
    const propertyValues = values[podsFilterFields.pods]

    if (checked) {
      setFieldValue(podsFilterFields.pods, {
        ...propertyValues,
        [option.optionMeta.id]: option,
      })
    } else {
      const { [option.optionMeta.id]: uncheckedOption, ...otherOptions } =
        propertyValues
      setFieldValue(podsFilterFields.pods, {
        ...otherOptions,
      })
    }
  }

  const renderOptions = () => {
    const meOptionIndex = options.findIndex(
      ({ option: { isMe } }: any) => !!isMe,
    )

    const selectedPods = values[podsFilterFields.pods] || {}

    if (meOptionIndex < 0) {
      return (
        <PodsOptionsList
          options={options}
          listTitle="All Pods"
          onCheckBoxClicked={onCheckBoxClicked}
          selectedOptions={selectedPods}
        />
      )
    }

    const clonedOptions = [...options]
    return (
      !disabled && (
        <Box maxHeight="300px" overflowY="auto">
          <PodsOptionsList
            options={clonedOptions}
            listTitle="All Pods"
            onCheckBoxClicked={onCheckBoxClicked}
            selectedOptions={selectedPods}
          />
        </Box>
      )
    )
  }

  return (
    <Box maxHeight="100%">
      {!disabled && (
        <Box p={theme.space[4] + 'px'}>
          <Input
            icon={<SearchRounded style={{ color: theme.colors.gray400 }} />}
            inputProps={{
              onChange: onSearchTextChange,
              placeholder: 'Search for a pod',
            }}
            id={undefined}
            prefix={undefined}
            postfix={undefined}
            endedIcon={undefined}
            containerProps={undefined}
          />
        </Box>
      )}

      {renderOptions()}

      {disabled && (
        <Alert variant="warningWithBg" mb={4} p={3}>
          <Flex
            alignItems="center"
            maxWidth="280px"
            color={theme.colors.pdfGray}
          >
            <UpgradeButton
              fontSize={theme.fontSizes.pExtraSmall10}
              padding={`${theme.space[1]}px ${theme.space[3]}px`}
            />
            <TextSpan
              as="span"
              fontSize={theme.fontSizes.pSmall12}
              lineHeight={theme.lineHeights.link}
              ml={3}
              mr={1}
            >
              Available on Group Bundle. <br /> Click Upgrade to enquire.
            </TextSpan>
          </Flex>
        </Alert>
      )}
    </Box>
  )
}
